// Consumer-facing helper copy for the AI review footer. A rebuild-v2 durable job with real-write
// available (rebuildCommitAvailable) is NOT a dry run, so it must never show the preview/dry-run text.
// No rollout/internal flag language is exposed to users.
export function reviewCommitNote(commitAvailable, rebuildCommitAvailable) {
  if (commitAvailable || rebuildCommitAvailable) {
    return 'Review portions and ingredients before logging. Optional items not added won’t be logged.';
  }
  return 'Preview — commit runs in dry-run (no data saved).';
}
